import { useGetContactsShort } from '@/api/requests/useGetContactsShort.util.ts';
import { EmailSelectOption } from '@/components/form/model/SelectSearchOption.model.ts';
import { useDebounce } from '@/utils/useDebounce.util.ts';

export const useHandleGetContactsSearch = () => {
  const { getContactsShort } = useGetContactsShort();

  return {
    handleGetContact: useDebounce(async (query: string): Promise<EmailSelectOption[]> => {
      if (!query) {
        return [];
      }
      const contactShortDtos = await getContactsShort({ query });
      const newContacts: EmailSelectOption[] = [];
      contactShortDtos.slice(0, 10).forEach(contact => {
        contact.emails.forEach(({ email }) => {
          newContacts.push({
            email,
            label: `${contact.displayName}<${email}>`,
            value: email,
          });
        });
      });

      return newContacts;
    }, 500),
  };
};
